<template>
    <div class="page">
        <MyHeader :breadcrumb="breadcrumb"></MyHeader>
        <div class="page-content">
            <el-card class="box-card" header="当前站点">
                <div class="card-content">
                  <h1>{{site.site_name}}</h1>
                  <a :href="siteUrl" target="_blank">预览</a>
                </div>

            </el-card>
            <el-card class="box-card stat" header="访客统计">
                <div class="seller">
                    <div class="site-stat">
                        <ul>
                            <li>
                                <div>浏览次数PV：</div>
                                <p>0</p>
                            </li>
                            <li>
                                <div>独立访客UV：</div>
                                <p>0</p>
                            </li>
                            <li>
                                <div>IP：</div>
                                <p>0</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </el-card>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    import MyHeader from "./header";

    export default {
        name: "home",
        components: {
            MyHeader
        },
        data(){
            return {
                user:{},
                site:{},
                siteId:'',
                userId:{},
                breadcrumb:[
                    {
                        name:'欢迎页',
                        url:'/admin/home'
                    }
                ],
                goodsCount:{},
                orderCount:{},
              siteUrl:''
            }
        },
        created(){
            var _this = this;
            this.siteId = Cookies.get('siteId')
            if (!this.siteId) {
                this.$router.push('/admin/multiple')
            }
            this.userId = Cookies.get('user_id')
            this.$http.get('/v1/user/view',{params:{userId:this.userId}}).then((res)=>{
                this.user = res.data;
            })
            this.$http.get('/v1/sites/view',{params:{siteId:this.siteId}}).then((res)=>{
                this.site = res.data.result;
            })
            this.$store.commit('setBreadcrumb',this.breadcrumb)
          this.siteUrl = 'http://'+this.siteId+'.'+this.siteDomain;
        },
        methods:{
            getSiteDomain(siteId){
                return 'http://' + siteId + '.' + this.siteDomain;
            },
          clickPreview(){

          }
        }
    }
</script>

<style scoped>

    .page-content h1{
        padding: 0 20px;
    }

    .page-content{
        padding:0;
        margin:20px;
    }
    .site-stat li{
        float: left;
        width: 33%;
        text-align: center;
    }
    .stat{
        margin:20px 0 0 0;
    }
  .card-content{
    display: flex;
    justify-content: space-between;
  }
</style>
